import MagicLinkRouter from './MagicLinkRouter'

export default MagicLinkRouter
